// extracted by mini-css-extract-plugin
var _1 = "NewsboardPostForm-moduleformBody__O8wDQ";
export { _1 as "formBody" }
